/**
 * useBlockReasons - Hook para obtener los motivos de bloqueo de shipments
 * 
 * Carga la lista completa de razones de bloqueo desde GET /invoices/block-reasons
 * con paginación de 1000 registros. Usa React Query para cachear los datos
 * durante 10 minutos y optimizar el rendimiento.
 * 
 * @returns {Object} { data: razones de bloqueo, isLoading, error, refetch }
 */

import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { ShipmentBlockReasonsApiAdapter } from '../adapters/ShipmentBlockReasonsApiAdapter';

export const useBlockReasons = () => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new ShipmentBlockReasonsApiAdapter(httpClient);

  return useQuery({
    queryKey: ['shipmentBlockReasons'],
    queryFn: () => adapter.getAll(),
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};


